import { supabase } from '@shared/supabaseClient';

const PORTAL_TOKEN_KEY = 'portal_session_token';
const PORTAL_EXPIRES_KEY = 'portal_session_expires_at';
const PORTAL_EMAIL_KEY = 'portal_session_email';

export function getPortalToken() {
  return localStorage.getItem(PORTAL_TOKEN_KEY);
}

export function getPortalTokenExpiry() {
  return localStorage.getItem(PORTAL_EXPIRES_KEY);
}

export function setPortalSession({ token, expires_at, email }) {
  if (token) {
    localStorage.setItem(PORTAL_TOKEN_KEY, token);
  }
  if (expires_at) {
    localStorage.setItem(PORTAL_EXPIRES_KEY, expires_at);
  }
  if (email) {
    localStorage.setItem(PORTAL_EMAIL_KEY, email);
  }
}

export function clearPortalSession() {
  localStorage.removeItem(PORTAL_TOKEN_KEY);
  localStorage.removeItem(PORTAL_EXPIRES_KEY);
  localStorage.removeItem(PORTAL_EMAIL_KEY);
}

export function isPortalSessionExpired() {
  const expiresAt = getPortalTokenExpiry();
  if (!expiresAt) return true;
  return new Date(expiresAt).getTime() <= Date.now();
}

export async function portalRequestCode(email) {
  const { data, error } = await supabase.functions.invoke('portal-request-code', {
    body: { email },
  });

  if (error) throw error;
  return data;
}

export async function portalVerifyCode(email, code, inviteToken = null) {
  const { data, error } = await supabase.functions.invoke('portal-verify-code', {
    body: { email, code, invite_token: inviteToken },
  });

  if (error) throw error;
  return data;
}

export async function portalMe(token) {
  const { data, error } = await supabase.functions.invoke('portal-me', {
    headers: {
      'x-portal-token': token,
    },
  });

  if (error) throw error;
  return data;
}

export async function portalSubmitInduction(inviteToken, answers, signatureDataUrl) {
  const portalToken = getPortalToken();
  if (!portalToken) {
    throw new Error('Missing portal session');
  }

  const { data, error } = await supabase.functions.invoke('portal-submit-induction', {
    headers: {
      'x-portal-token': portalToken,
    },
    body: {
      invite_token: inviteToken,
      answers,
      signature_data_url: signatureDataUrl,
    },
  });

  if (error) throw error;
  return data;
}

/**
 * Submit induction by submission_id (multi-brief / email-based flow).
 * Uses the portal_submit_by_submission_id RPC directly (no Edge Function needed
 * because the RPC handles all validation via email matching).
 */
export async function portalSubmitBySubmissionId(submissionId, email, answers, signatureDataUrl) {
  const { data, error } = await supabase.rpc('portal_submit_by_submission_id', {
    p_submission_id: submissionId,
    p_email: email,
    p_answers: answers,
    p_signature_data_url: signatureDataUrl,
  });

  if (error) throw error;
  return data;
}
